export default __webpack_public_path__ + "static/media/nv11.586b2f9b.PNG";